import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import draggable from "vuedraggable";
import { mapGetters, mapActions } from "vuex";
import Banner from "@/components/office/Banner";
import CARD from "@/components/office/CARD";
import TOPIC from "@/components/office/TOPIC";
import TOPICDL from "@/components/office/TOPICDL";
import SUBJECT from "@/components/office/SUBJECT";
import SUBJECTDL from "@/components/office/SUBJECTDL";
import COMMENT from "@/components/office/COMMENT";
import LINK from "@/components/office/LINK";
export default {
  name: "card",
  components: {
    draggable: draggable,
    Banner: Banner,
    CARD: CARD,
    TOPIC: TOPIC,
    TOPICDL: TOPICDL,
    SUBJECT: SUBJECT,
    SUBJECTDL: SUBJECTDL,
    COMMENT: COMMENT,
    LINK: LINK
  },
  props: ["childModules"],
  data: function data() {
    return {
      baseUrl: process.env.BASE_URL,
      selectedModules: [],
      displayModuleList: []
    };
  },
  created: function created() {
    this.defualtSelectedModules();
  },
  computed: _objectSpread({}, mapGetters(["moduleList"])),
  methods: {
    addModule: function addModule(e) {
      var targetIndex = e.newIndex;
      var childModulesIndex = e.oldIndex;
      var childModule = this.childModules[childModulesIndex]; // 判断添加的模块是否存在

      var exist = this.selectedModules.some(function (item) {
        return item.id === childModule.id;
      });

      if (exist) {
        this.$message.warning("不能重复添加已添加的模块");
        return;
      }

      this.selectedModules.splice(targetIndex, 0, childModule);
      this.$emit("caseChanged", true);
    },
    addButton: function addButton(data) {
      // 判断添加的模块是否存在
      var exist = this.selectedModules.some(function (item) {
        return item.id === data.id;
      });

      if (exist) {
        this.$message.warning("不能重复添加已添加的模块");
        return;
      }

      this.selectedModules.push(data);
      this.$emit("caseChanged", true);
    },
    sortModule: function sortModule(e) {
      var newIndex = e.newIndex;
      var oldIndex = e.oldIndex;
      var selectedModule = this.selectedModules[oldIndex];
      this.selectedModules.splice(oldIndex, 1);
      this.selectedModules.splice(newIndex, 0, selectedModule);
      this.$emit("caseChanged", true);
    },
    removeModules: function removeModules(item, index) {
      this.selectedModules.splice(index, 1);
      this.$emit("caseChanged", true);
    },
    isEmpty: function isEmpty() {
      return this.selectedModules.length ? false : true;
    },
    defualtSelectedModules: function defualtSelectedModules() {
      var _this = this;

      this.moduleList.forEach(function (item) {
        _this.childModules.forEach(function (element) {
          if (item.cardType === element.code) {
            _this.selectedModules.push(element);
          }
        });
      });
    }
  },
  watch: {
    selectedModules: function selectedModules(val) {
      var _this2 = this;

      this.$emit("selectedChange", {
        data: val,
        module: "home"
      });
      val.forEach(function (item) {
        _this2.moduleList.forEach(function (e) {
          if (e.cardType === item.code) {
            _this2.displayModuleList.push(e);
          }
        });
      });
    }
  },
  filters: {}
};